import { useSeoMeta } from "@unhead/react";
import { Hero } from "@/components/site/Hero";
import { Portfolio } from "@/components/site/Portfolio";

const Index = () => {
  useSeoMeta({
    title: "Let's Talk",
    description: "",
  });

  return (
    <>
      <Hero />
      <Portfolio />
    </>
  );
};

export default Index;